import { render, staticRenderFns } from "./AddTrigger.vue?vue&type=template&id=518dadee"
import script from "./AddTrigger.vue?vue&type=script&lang=js"
export * from "./AddTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports